export default "__VITE_ASSET__Clfy$oWf__"